// Som de "pedido novo" do catálogo (Web Audio — sem arquivo). Três notas subindo, repetidas 2x,
// mais forte que o som do chat para chamar atenção no balcão.
// Navegadores só liberam áudio depois que a pessoa clicou na página ao menos uma vez (regra do Chrome).

let ctx = null;

export function tocarSomPedido() {
  try {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!ctx) ctx = new AC();
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
    const notas = [988, 1319, 1568]; // si, mi, sol
    const inicio = ctx.currentTime + 0.05;
    for (let rep = 0; rep < 2; rep++) {
      notas.forEach((freq, i) => {
        const t = inicio + rep * 0.75 + i * 0.16;
        const osc = ctx.createOscillator();
        const gan = ctx.createGain();
        osc.type = 'triangle';
        osc.frequency.value = freq;
        gan.gain.setValueAtTime(0.0001, t);
        gan.gain.exponentialRampToValueAtTime(0.5, t + 0.02);
        gan.gain.exponentialRampToValueAtTime(0.0001, t + 0.28);
        osc.connect(gan).connect(ctx.destination);
        osc.start(t);
        osc.stop(t + 0.3);
      });
    }
  } catch { /* sem áudio: segue só com o aviso visual */ }
}

// Pré-aquece o áudio no primeiro clique (assim o som do próximo pedido já toca).
export function prepararSomPedido() {
  const liberar = () => {
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      if (AC && !ctx) ctx = new AC();
      if (ctx && ctx.state === 'suspended') ctx.resume().catch(() => {});
    } catch { /* ignore */ }
    window.removeEventListener('pointerdown', liberar);
  };
  window.addEventListener('pointerdown', liberar);
  return () => window.removeEventListener('pointerdown', liberar);
}
